/** @type {import ('@sveltejs/kit').ParamMatcher} */
export function match(param) {
  // check if the param is page-<number>
  return !!param.match(/^page-\d+$/);
}